import { FormStore } from '@roc/feature-app-core';
import { makeObservable, observable } from 'mobx';
import {
  generateUUID,
} from '@roc/feature-utils';

const REQUIRED_ERROR_MESSAGE = "This field is required.";

const initialForm = {
  fields: {
    fieldName: {
      value: '',
      error: null,
      rule: 'required',
      message: REQUIRED_ERROR_MESSAGE,
    },
    amount: {
      value: '',
      error: null,
      rule: 'required',
      message: REQUIRED_ERROR_MESSAGE,
    },
    completed: {
      value: false,
      error: null,
      rule: ''
    },
    completedEnabled: {
      value: '',
      error: null,
      rule: ''
    }
  },
  meta: {
    key: null,
    editMode: false,
    isValid: false,
    showErrors: null,
    error: null,
  },
}
export class DrawFieldFormStore extends FormStore {
  public uuid: string;


  constructor(globalStore) {
    super(initialForm, globalStore);
    this.uuid = generateUUID();

    makeObservable(this, {
      uuid: observable
    });
  }
}